import React from "react";
import darkLogo from "../assets/images/brand/election-atlas_horizontal_on-dark.svg";
import lightLogo from "../assets/images/brand/election-atlas_horizontal_on-light.svg";
import {THEME_MODES} from "../theme";

export default function BrandLogo({themeMode, alt, className}) {
  return <img src={themeMode === THEME_MODES.light ? lightLogo : darkLogo} alt={alt} className={className} />;
}
